import { createApp } from "vue";
import { createPinia } from 'pinia'
import App from "./App.vue";
import PrimeVue from 'primevue/config'
import router from "./router";
import Dialog from 'primevue/dialog'
import MultiSelect from "primevue/multiselect";
import ConfirmationService from 'primevue/confirmationservice'
import ToastService from 'primevue/toastservice'
import Toast from 'primevue/toast'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Skeleton from 'primevue/skeleton'
import Dropdown from "primevue/dropdown";
import axios from 'axios';

import "@/assets/scss/argon.scss";
import "@/assets/scss/_custom.scss";
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'primevue/resources/themes/aura-light-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import '@/styles/css/shared-styles.css'

const pinia = createPinia()


const app = createApp(App)
	.use(router)
	.use(PrimeVue)
	.use(ToastService)
	.use(pinia)
	.component('Dialog', Dialog)
	.component('MultiSelect', MultiSelect)
	.component('DataTable', DataTable)
	.component('Column', Column)
	.component('Toast', Toast)
    .component('Skeleton', Skeleton)
	.component('Dropdown', Dropdown)
	.use(ConfirmationService);

app.config.globalProperties.axios = axios;

app.mount('#app');

import { useSessionStore } from '@/stores/session'
useSessionStore().loadFromStorage?.()
